const route = [
    {//选择作业类型
        //subject：51小学语文
        path: '/chineseChooseType/:subject',
        component: function (resolve) {
            require(['VIEWS/chinese/chooseTaskType'], resolve);
        }
    },
    {//语文发作业
        //subject：51小学语文
        path: '/chinese/release/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/chinese/module/release.vue'], resolve);
        }
    },
];
export default route
